// removed by extract-text-webpack-plugin
module.exports = {"catalog-card":"catalog-card___2pksc","cover-lots":"cover-lots___3qUZ3","featured":"featured___2hbnC","card-body":"card-body___13BXC","left":"left___3IuZp","title":"title___2jz91","seller":"seller___23oJW","date":"date___3Y4jh","featured-left":"featured-left___3-aCI","right":"right___14GH1","explore":"explore___20aW9","flag":"flag___1GRva","live":"live___13H-I","countdown":"countdown___2ufl1","ended":"ended___38HnW"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CatalogCard/CatalogCard.scss
// module id = OMSM
// module chunks = 57